'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gt = gt;
exports.lt = lt;
exports.eq = eq;
exports.gte = gte;
exports.lte = lte;
exports.neq = neq;
exports.validate = validate;
// (function (global, factory) {
//   typeof exports === 'object' && typeof module !== 'undefined' 
//     ? module.exports = factory() 
//     : typeof define === 'function' && define.amd 
//       ? define(factory) 
//       : (global.simpleSemver = factory());
// })(this, function() {

function gt(a, b) {
  if (!_validate(a, b)) {
    return false;
  }
  return _cleanCompare(a, b) === 'GT';
}

function lt(a, b) {
  if (!_validate(a, b)) {
    return false;
  }
  return _cleanCompare(a, b) === 'LT';
}

function eq(a, b) {
  if (!_validate(a, b)) {
    return false;
  }
  return _cleanCompare(a, b) === 'EQ';
}

function gte(a, b) {
  if (!_validate(a, b)) {
    return false;
  }
  var result = _cleanCompare(a, b);
  return result === 'GT' || result === 'EQ';
}

function lte(a, b) {
  if (!_validate(a, b)) {
    return false;
  }
  var result = _cleanCompare(a, b);
  return result === 'LT' || result === 'EQ';
}

function neq(a, b) {
  if (!_validate(a, b)) {
    return false;
  }
  return _cleanCompare(a, b) !== 'EQ';
}

function validate(data) {
  if (typeof data !== 'string') {
    return false;
  }
  data = data.replace(/-alpha/g, '');
  var arr = data.split('.');
  if (arr.length !== 3) {
    return false;
  }
  var pass = arr.every(function (el) {
    return (/^[0-9]+$/.test(el)
    );
  });
  return pass;
}

function _cleanCompare(a, b) {
  return _compareVersion(_clean(a), _clean(b));
}

function _compare(a, b) {
  return a === b ? 'EQ' : a > b ? 'GT' : 'LT';
}

function _compareVersion(a, b) {
  if (a.join('.') === b.join('.')) {
    return 'EQ';
  }

  for (var i = 0; i < a.length; i++) {
    var result = _compare(a[i], b[i]);
    switch (result) {
      case 'EQ':
        continue;
        break;
      case 'GT':
        return 'GT';
      case 'LT':
        return 'LT';
    }
  }
}

function _validate(a, b) {
  return validate(a) && validate(b);
}

function _clean(data) {
  return data.replace(/-alpha/g, '').split('.').map(Number);
}

// return {
//   gt,
//   lt,
//   gte,
//   lte,
//   eq
// }

// })


//////////////////
// WEBPACK FOOTER
// ./node_modules/simple-semver/lib/index.js
// module id = 153
// module chunks = 0